module.exports = __webpack_public_path__ + "de2cbe13a6be01d469c750a6e9266486.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/medias/images/sque.png
// module id = 881
// module chunks = 3